/* eslint-disable @typescript-eslint/indent */
/* eslint-disable no-cond-assign */
/* eslint-disable @next/next/no-img-element */
import { Typography } from '@pwskills/rachnaui';
import { People } from '@pwskills/rachnaui/Icons';
import React from 'react';
import ClockIcon from '@/assets/icons/ClockIcon';
import usePostLoginStates from '@/store/PostLoginStore/usePostLoginStates';
import { useRouter } from 'next/router';
import { GAevent } from '@/utils/firebase.utils';
import useUserDetails from '@/store/userDetails';
import { domainUrl, medharthiDomainUrl } from '@/utils/common/env.constants';
import useScreenWidth from '@/hooks/useScreenWidth';
import { sendSkCourseCardClickEvent } from '@/utils/GAEventFunction';
import { CoursesType, PostLoginGAevents } from '../Utilities/enums';
import { IRecommendedCourse } from '../Utilities/Interfaces/RecommendedCourses';
import { handleEnrollmentData, showEnrollment } from './utils';
import { returnImageUrl } from '../Utilities/common.function';
import { CategoryPayload } from '../AllCourses/utils/interface';

const RecommendedCoursesCard = ({
  cardInfo,
  category,
  cardPosition,
}: {
  cardInfo: IRecommendedCourse;
  category?: CategoryPayload;
  cardPosition?: number;
}) => {
  const { setCourseSlug, systemTime } = usePostLoginStates();
  const router = useRouter();
  const width = useScreenWidth();
  const { userDetails } = useUserDetails();
  const { selectedCategory } = usePostLoginStates();
  const onCardClick = () => {
    sendSkCourseCardClickEvent({
      userData: userDetails,
      isLoggedIn: !!userDetails?.id,
      page_referrer_cta: 'course card',
      page_referrer_widget_name: 'recommended_courses',
      card_id: cardInfo?._id,
      card_title: cardInfo?.title || cardInfo?.batchName || cardInfo?.name,
      card_category: selectedCategory?.title,
      card_position: cardPosition,
      card_section: 'recommended',
      course_batch_name: cardInfo?.batchName || cardInfo?.title || cardInfo?.name,
      course_batch_slug: cardInfo?.slug,
      course_batch_category: selectedCategory?.title,
      course_batch_id: cardInfo?._id,
      course_batch_cohort_id: selectedCategory?._id || category?._id,
      price: cardInfo?.pricing?.IN,
      discount_percentage: cardInfo?.pricing?.discount,
      is_free: cardInfo?.pricing?.isFree,
    });
    GAevent(PostLoginGAevents.OVERVIEW_CLICK, {
      user_id: userDetails?.id,
      user_category: userDetails?.profileId?.userType,
      component_click: PostLoginGAevents.COURSE_CLICK,
    });
    GAevent(PostLoginGAevents.COURSE_CARD_CLICK, {
      user_id: userDetails?.id,
      user_category: userDetails?.profileId?.userType,
      component_click: PostLoginGAevents.COURSE_CLICK,
      category_name: selectedCategory?.title,
      category_id: selectedCategory?._id,
      course_id: cardInfo?._id,
      course_type: cardInfo?.pricing?.isFree ? 'free' : 'paid',
    });
    if (cardInfo?.courseType === CoursesType.ONLINE_DEGREE) {
      if (cardInfo.isPremiumOnlineDegreeCourse)
        window.open(
          `https://${cardInfo?.partnerInstitute?.subDomain}.pwskills.com/degree/${cardInfo?.slug}`,
          '_blank'
        );
      else {
        const isMedharthiDomain = window.location.hostname.includes('pwmedharthi.com');
        if (isMedharthiDomain) {
          window.open(`${medharthiDomainUrl}/courses/${cardInfo?.slug}`, '_blank');
        } else {
          window.open(`${domainUrl}/degree/${cardInfo?.slug}`, '_blank');
        }
      }
      return;
    }
    if (typeof window !== 'undefined') localStorage.setItem('courseId', cardInfo?._id);
    if (category?.slug) router.push(`/${category?.slug}/${cardInfo?.slug}`);
    setCourseSlug(cardInfo?.slug);
  };
  if (!width) return null;
  return (
    <button
      type="button"
      onClick={onCardClick}
      className="flex flex-col p-2 gap-2 border border-stroke-200 rounded-lg bg-white !w-[260px] flex-none h-[245px] justify-between"
    >
      <img
        src={returnImageUrl(cardInfo?.img || cardInfo?.previewImageUrl)}
        alt="img"
        className="w-full  rounded-lg h-[140px]"
      />
      <Typography
        component="body-small"
        variant="bold"
        className="line-clamp-2 text-left text-gray-850 !text-[14px]"
      >
        {cardInfo?.title || cardInfo?.batchName || cardInfo?.name}
      </Typography>
      <div className="bg-stroke-200 h-[1px]" />
      <div className="flex gap-2">
        <div className="flex items-center gap-1 whitespace-nowrap">
          <ClockIcon height="16" />
          <Typography component="body-small" variant="semi-bold" className="text-gray-650">
            {cardInfo?.duration || cardInfo?.config?.duration}
          </Typography>
        </div>
        {showEnrollment(cardInfo, systemTime) && (
          <div className="flex items-center justify-center gap-1 whitespace-nowrap">
            <People className="text-gray-650 w-4 h-4" />
            <Typography component="body-small" variant="semi-bold" className="text-gray-650">
              {handleEnrollmentData(cardInfo)} Enrolled
            </Typography>
          </div>
        )}
      </div>
    </button>
  );
};

export default RecommendedCoursesCard;
